import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LoginService } from './services/login.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  
  
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'mondial-costadoro-app';

  constructor(private loginService: LoginService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)){
      this.getBusinessAndStore();
    }
  }

getBusinessAndStore() {
    this.loginService.getBusinessTypeDetails(window.location.origin).subscribe({
      next: (data: any) => {
        localStorage.setItem('reference_number', data.reference_number);
        localStorage.setItem('logo_url', data.logo_url);
        localStorage.setItem('website_url', data.website_url);
        localStorage.setItem('brand', data.brand);
        localStorage.setItem('thumbnail_logo', data.thumbnail_url);
        localStorage.setItem('support_email', data.support_email ?? '');
        localStorage.setItem('support_phone', data.support_phone ?? '');
      },
      error: (error) => {
        console.error('Failed to get business type details:', error);
      },
    });
  }
}
